// extracted by mini-css-extract-plugin
module.exports = {"menu":"selectStyle-module--menu--3Y1kL","fadeIn":"selectStyle-module--fade--in--2DQ_o"};